import {Route} from 'react-router-dom';
import React, {Component, Fragment} from 'react';
import Navbar from "./Navbar";
import Gallery from "./Gallery";
import Uploader from "./Uploader";
import CreateAlbum from "./CreateAlbum";
import Albums from "./Albums";
import EditPhoto from "./EditPhoto";
import ManageGallery from "./ManageGallery";


export default class Root extends Component {
    render() {
        return (
            <Fragment>
                <Route path="/" render={(props) => (
                    <Navbar {...props}/>
                )}/>

                <div className="container-fluid">
                    <Route exact path="/" component={Albums}/>
                    <Route exact path="/albums/:album" component={Gallery}/>
                    {user.admin ?
                        <Route exact path="/album/create" component={CreateAlbum}/>
                    : null}
                    {user.admin ?
                        <Route exact path="/upload" component={Uploader}/>
                    : null}
                    {user.admin ?
                        <Route exact path="/photo/:id" component={EditPhoto}/>
                    : null}
                    {user.admin ?
                        <Route exact path="/manage" component={ManageGallery}/>
                    : null}
                </div>
            </Fragment>
        );
    }
}


// WEBPACK FOOTER //
// ./resources/assets/js/components/Root.js